<template>
    <div>
        <div>
            <el-menu
                mode="horizontal"
                class="topmenu"
                :default-active="activeIndex"
                @select="handleSelect"
            >
                <el-menu-item index="1">基础设置</el-menu-item>
                <el-menu-item index="2">其他设置</el-menu-item>
            </el-menu>
            <div class="form-container" v-show="activeIndex == 1">
                <el-form label-position="left" :model="info" size="small" :rules="rules" ref="info">
                    <el-form-item label="更换头像" prop="avatar" :label-width="formLabelWidth">
                        <SingleImg
                            :img="info.avatar"
                            :Width="80"
                            :Height="80"
                            size="80*80"
                            @getPic="addChangeImg"
                        />
                    </el-form-item>
                    <el-form-item label="昵称" prop="nickname" :label-width="formLabelWidth">
                        <el-input
                            placeholder
                            style="width:200px"
                            v-model="info.nickname"
                            :size="inputSize"
                        />
                    </el-form-item>
                    <el-form-item label="电子邮箱" prop="email" :label-width="formLabelWidth">
                        <el-input
                            placeholder
                            style="width:200px"
                            type="email"
                            v-model="info.email"
                            :size="inputSize"
                        />
                    </el-form-item>
                    <el-form-item label="手机号" prop="phone" :label-width="formLabelWidth">
                        <div class="phonecontent">
                            <p class="number">{{info.phone|phoneFilter}}</p>
                            <i class="el-icon-success"></i>
                            <p class="success">已验证</p>
                        </div>
                    </el-form-item>
                    <el-form-item label="所在省" prop="province" :label-width="formLabelWidth">
                        <el-select
                            v-model="info.province"
                            placeholder="全部"
                            :size="inputSize"
                            style="margin: 0 10px;"
                            @change="changeProvince"
                        >
                            <el-option
                                v-for="item in provinceList"
                                :key="item.code"
                                :label="item.name"
                                :value="item.code"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="所在市" prop="city" :label-width="formLabelWidth">
                        <el-select
                            v-model="info.city"
                            placeholder="全部"
                            :size="inputSize"
                            style="margin: 0 10px;"
                            @change="changeCity"
                        >
                            <el-option
                                v-for="item in cityList"
                                :key="item.code"
                                :label="item.name"
                                :value="item.code"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="所在区" prop="county" :label-width="formLabelWidth">
                        <el-select
                            v-model="info.county"
                            placeholder="全部"
                            :size="inputSize"
                            style="margin: 0 10px;"
                        >
                            <el-option
                                v-for="item in countryList"
                                :key="item.code"
                                :label="item.name"
                                :value="item.code"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="职业" prop="work" :label-width="formLabelWidth">
                        <el-select v-model="info.work" placeholder="请选择">
                            <el-option
                                v-for="item in jobList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.name"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="个人简介" prop="describe" :label-width="formLabelWidth">
                        <el-input
                            placeholder
                            v-model="info.describe"
                            style="width:300px"
                            :size="inputSize"
                        />
                    </el-form-item>
                    <el-form-item label="标签" prop="label" :label-width="formLabelWidth">
                        <el-select multiple v-model="info.label" placeholder="请选择">
                            <el-option
                                v-for="item in labelList"
                                :key="item.id"
                                :label="item.title"
                                :value="item.id"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="主要成就" prop="achievement" :label-width="formLabelWidth">
                        <el-input
                            placeholder="200字以内"
                            type="textarea"
                            :autosize="{ minRows: 3, maxRows: 5}"
                            style="width: 80%;"
                            v-model="info.achievement"
                            :size="inputSize"
                        />
                    </el-form-item>
                </el-form>
                <div class="bottom-btn">
                    <el-button type="primary" @click="submit()">确认修改</el-button>
                </div>
            </div>
            <div class="form-container" v-show="activeIndex == 2">
                <div class="pass">
                    <el-form
                        :model="passForm"
                        :rules="passRules"
                        ref="ruleForm"
                        label-width="100px"
                        class="pass-form"
                        label-position="left"
                    >
                        <el-form-item prop="oldpassword" label="输入旧密码：">
                            <el-input
                                placeholder="请输入旧密码"
                                v-model="passForm.oldpassword"
                                type="password"
                                show-password
                            ></el-input>
                        </el-form-item>
                        <el-form-item prop="newpassword" label="输入新密码：">
                            <el-input
                                placeholder="请输入8-16位新密码，包含字母及数字"
                                v-model="passForm.newpassword"
                                type="password"
                                show-password
                            ></el-input>
                        </el-form-item>
                        <el-form-item prop="checkPass" label="确认新密码：">
                            <el-input
                                placeholder="请确认密码"
                                v-model="passForm.checkPass"
                                type="password"
                                show-password
                            ></el-input>
                        </el-form-item>
                    </el-form>
                    <el-button type="primary" @click="setNewPass">修改密码</el-button>
                </div>
                <div class="phone">
                    <el-form
                        :model="phoneForm"
                        :rules="phoneRules"
                        ref="ruleForm"
                        label-width="100px"
                        class="phone-form"
                        label-position="left"
                    >
                        <div class="cell-phone">
                            <el-form-item prop="phone" label="旧手机号：">
                                <el-input
                                    placeholder="手机号"
                                    v-model="phoneForm.oldphone"
                                    class="input-with-select"
                                    type="number"
                                    pattern="[0-9]*"
                                    onkeypress="return( /[\d]/.test(String.fromCharCode(event.keyCode) ) )"
                                ></el-input>
                            </el-form-item>
                            <el-form-item prop="code">
                                <el-input
                                    placeholder="验证码"
                                    v-model="phoneForm.oldcode"
                                    type="number"
                                    pattern="[0-9]*"
                                ></el-input>
                            </el-form-item>
                            <el-button
                                @click="getCode('old')"
                                :disabled="oldPhoneCodeGet"
                            >{{ oldPhoneCodeText }}</el-button>
                        </div>
                        <div class="cell-phone">
                            <el-form-item prop="phone" label="新手机号：">
                                <el-input
                                    placeholder="手机号"
                                    v-model="phoneForm.newphone"
                                    class="input-with-select"
                                    type="number"
                                    pattern="[0-9]*"
                                    onkeypress="return( /[\d]/.test(String.fromCharCode(event.keyCode) ) )"
                                ></el-input>
                            </el-form-item>
                            <el-form-item prop="code">
                                <el-input
                                    placeholder="验证码"
                                    v-model="phoneForm.newcode"
                                    type="number"
                                    pattern="[0-9]*"
                                ></el-input>
                            </el-form-item>
                            <el-button
                                @click="getCode('new')"
                                :disabled="newPhoneCodeGet"
                            >{{ newPhoneCodeText }}</el-button>
                        </div>
                    </el-form>
                    <el-button type="primary" @click="setNewPhone">修改手机号</el-button>
                    <!-- <div class="tips">友情提示：验证码有效期为三分钟，请您尽快完成操作</div> -->
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import SingleImg from '../content/singleImg';
    import { CHINA_MOBILE } from '../../request/regular';
    import { mapActions } from 'vuex';
    export default {
        components: {
            SingleImg
        },
        data() {
            var validatePass = (rule, value, callback) => {
                console.log('validatePass', value);
                if (value === '') {
                    callback(new Error('请输入密码'));
                } else {
                    let regu = /^(?=.*[a-zA-Z])(?=.*[0-9])[a-zA-Z0-9]{6,16}$/;
                    if (!regu.test(value)) {
                        callback(new Error('密码需为8-16位字母加数字组合'));
                    }
                    if (this.passForm.checkPass !== '') {
                        this.$refs.passForm.validateField('checkPass');
                    }
                    callback();
                }
            };

            var validatePass2 = (rule, value, callback) => {
                console.log('validatePass222', rule, value);
                let password = this.passForm.newpassword;

                if (value === '') {
                    callback(new Error('请再次输入密码'));
                } else if (value !== password) {
                    callback(new Error('两次输入密码不一致!'));
                } else {
                    callback();
                }
            };
            var checkPhone = (rule, value, callback) => {
                if (!value) {
                    return callback(new Error('手机号不能为空'));
                }
                setTimeout(() => {
                    if (!CHINA_MOBILE.test(value)) {
                        callback(new Error('请输入正确的手机号'));
                    } else {
                        callback();
                    }
                }, 1000);
            };
            return {
                personalquery: '',
                activeIndex: '1',
                rules: {},
                inputSize: 'small',
                formLabelWidth: '100px',
                labelList: [],
                area: {
                    cityList: [], // 市
                    countryList: [] // 区
                },
                provinceList: [], // 省
                cityList: [], // 市
                countryList: [], // 区
                jobList: [
                    {
                        id: 1,
                        name: '锅炉-炉内防磨'
                    },
                    {
                        id: 2,
                        name: '锅炉-布风装置'
                    },
                    {
                        id: 3,
                        name: '锅炉-分离器'
                    },
                    {
                        id: 4,
                        name: '锅炉-返料器'
                    },
                    {
                        id: 5,
                        name: '烟气-烟气余热'
                    },
                    {
                        id: 6,
                        name: '冷渣-冷渣设备'
                    },
                    {
                        id: 7,
                        name: '锅炉-燃料制备'
                    },
                    {
                        id: 8,
                        name: '飞灰-飞灰再循环'
                    },
                    {
                        id: 9,
                        name: '节油-节油技术'
                    },
                    {
                        id: 10,
                        name: '拟态-拟态研究'
                    },
                    {
                        id: 11,
                        name: '传媒-电厂传媒'
                    },
                    {
                        id: 12,
                        name: '其他职业'
                    }
                ],
                info: {
                    nickname: '',
                    email: '',
                    work: '',
                    province: '',
                    city: '',
                    county: '',
                    describe: '',
                    label: [],
                    achievement: '',
                    website: ''
                },
                newPhoneCodeGet: false,
                newPhoneCodeText: '获取验证码',
                oldPhoneCodeText: '获取验证码',
                oldPhoneCodeGet: false,
                passForm: {
                    oldpassword: '',
                    newpassword: '',
                    checkPass: ''
                },
                passRules: {
                    oldpassword: [{ validator: validatePass, trigger: 'blur' }],
                    newpassword: [{ validator: validatePass, trigger: 'blur' }],
                    checkPass: [{ validator: validatePass2, trigger: 'blur' }]
                },
                phoneForm: {
                    oldphone: '',
                    oldcode: '',
                    newphone: '',
                    newcode: ''
                },
                phoneRules: {
                    oldphone: [{ validator: checkPhone, trigger: 'blur' }],
                    oldcode: [
                        { required: true, message: '请填写验证码', trigger: 'blur' }
                    ],
                    newphone: [{ validator: checkPhone, trigger: 'blur' }],
                    newcode: [
                        { required: true, message: '请填写验证码', trigger: 'blur' }
                    ]
                },
                oldToken: ''
            };
        },
        filters: {
            phoneFilter(value) {
                if (value) {
                    return value.substr(0, 3) + '****' + value.substr(7);
                }
            }
        },
        async created() {
            this.getLabel();
            await this.getAllArea();
            this.getpersonal();
        },
        methods: {
            ...mapActions(['getUserInfo']),
            handleSelect(key) {
                this.activeIndex = key;
                console.log(key);
            },
            changeProvince(val) {
                // 省份发生变化，更改市列表
                this.info.city = '';
                this.info.country = '';
                this.cityList = [];
                this.area.cityList.forEach(item => {
                    if (item.code.startsWith(val.substr(0, 2))) {
                        this.cityList.push(item);
                    }
                });
            },
            changeCity(val) {
                // 市发生变化，更改区列表
                this.countryList = [];
                this.info.country = '';
                this.area.countryList.forEach(item => {
                    if (item.code.startsWith(val.substr(0, 4))) {
                        this.countryList.push(item);
                    }
                });
            },
            addChangeImg(val) {
                // 上传图片
                this.$set(this.info, 'avatar', val);
            },
            async getAllArea() {
                await this.httpGet(this.$root.getAllArea)
                    .then(res => {
                        this.provinceList = this.format2list(res.province_list);
                        this.area.cityList = this.format2list(res.city_list);
                        this.area.countryList = this.format2list(res.county_list);
                        this.loading = false;
                    })
                    .catch(err => {
                        this.loading = false;
                        console.error('label-err', err);
                    });
            },
            format2list(obj) {
                let List = [
                    {
                        name: '全部',
                        code: ''
                    }
                ];
                Object.keys(obj).forEach(item => {
                    List.push({
                        name: obj[item],
                        code: item
                    });
                });
                return List;
            },
            getLabel() {
                this.httpGet(this.$root.labelList, {
                    page: 1,
                    size: 9999
                })
                    .then(res => {
                        this.labelList = res.list;
                        this.loading = false;
                    })
                    .catch(err => {
                        this.loading = false;
                        console.error('label-err', err);
                    });
            },
            getpersonal() {
                this.httpGet(this.$root.getUserInfo)
                    .then(result => {
                        for (let i in this.info) {
                            this.$set(this.info, i, result[i]);
                        }
                        this.$set(this.info, 'avatar', result.avatar);
                        this.info.phone = result.phone;
                        this.info.label = result.label.map(item => item.lid);
                        console.log(2222, this.info.label);
                        // this.info.phone = result.phone;
                        this.area.cityList.forEach(item => {
                            if (
                                item.code.startsWith(result.province.substr(0, 2))
                            ) {
                                this.cityList.push(item);
                            }
                        });
                        this.area.countryList.forEach(item => {
                            if (item.code.startsWith(result.city.substr(0, 4))) {
                                this.countryList.push(item);
                            }
                        });
                    })
                    .catch(error => {
                        console.log(error);
                    });
            },
            submit() {
                this.httpPost(this.$root.setUserInfo, this.info)
                    .then(result => {
                        this.$message({
                            type: 'success',
                            message: '修改成功！'
                        });
                        this.getUserInfo();
                        // location.reload();
                    })
                    .catch(error => {
                        console.log(error);
                    });
            },
            setNewPass() {
                let passValue = Object.values(this.passForm);
                if (passValue.indexOf('') > -1) {
                    this.$message({
                        message: '请完整填写',
                        type: 'warning'
                    });
                    return;
                }
                this.$confirm('确定要修改吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
                    .then(() => {
                        this.httpPost(this.$root.setNewPass, {
                            ...this.passForm
                        })
                            .then(result => {
                                this.$message({
                                    message: '修改成功',
                                    type: 'success'
                                });
                                this.getUserInfo();
                                // location.reload();
                            })
                            .catch(err => {
                                console.error('setNewPass-err', err);
                            });
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: '已取消'
                        });
                    });
            },
            getCode(opt) {
                let phone = this.phoneForm.oldphone;
                if (opt === 'new') {
                    phone = this.phoneForm.newphone;
                }
                if (!CHINA_MOBILE.test(phone)) {
                    this.$message({
                        message: '请输入正确的手机号',
                        type: 'warning'
                    });
                    return;
                }
                this.httpPost(this.$root.getMessageCode, {
                    phone: phone,
                    type: opt === 'new' ? 4 : 3
                })
                    .then(result => {
                        this.setTime(opt);
                    })
                    .catch(err => {
                        console.error('getMessageCode-err', err);
                    });
            },
            async setNewPhone() {
                let phoneValue = Object.values(this.phoneForm);

                if (phoneValue.indexOf('') > -1) {
                    this.$message({
                        message: '请完整填写',
                        type: 'warning'
                    });
                    return;
                }
                this.$confirm('确定要修改吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
                    .then(() => {
                        this.httpPost(this.$root.getUserVerify, {
                            phone: this.phoneForm.oldphone,
                            code: this.phoneForm.oldcode,
                            type: 3
                        })
                            .then(result => {
                                this.oldToken = result.access_token;
                                this.httpPost(this.$root.setNewPhone, {
                                    token: this.oldToken,
                                    phone: this.phoneForm.newphone,
                                    code: this.phoneForm.newcode
                                })
                                    .then(res => {
                                        this.$message({
                                            message: '修改成功',
                                            type: 'success'
                                        });
                                        this.getUserInfo();
                                        // location.reload();
                                    })
                                    .catch(err => {
                                        console.error('setNewphone-err', err);
                                    });
                            })
                            .catch(err => {
                                console.error('getUserVerify-err', err);
                            });
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: '已取消'
                        });
                    });
            },
            setTime(opt) {
                //    倒计时
                let demo = 180;
                if (opt === 'new') {
                    this.newPhoneCodeText = '(' + demo + 'S)';
                    this.newPhoneCodeGet = true;
                }
                if (opt === 'old') {
                    this.oldPhoneCodeText = '(' + demo + 'S)';
                    this.oldPhoneCodeGet = true;
                }
                let setTer = setInterval(() => {
                    if (demo > 0) {
                        if (opt === 'new') {
                            this.newPhoneCodeText = '(' + demo + 'S)';
                            // this.newPhoneCodeGet = true;
                        }
                        if (opt === 'old') {
                            this.oldPhoneCodeText = '(' + demo + 'S)';
                            // this.oldPhoneCodeGet = true;
                        }
                        demo--;
                    } else {
                        clearInterval(setTer);
                        if (opt === 'old') {
                            this.oldPhoneCodeText = '获取验证码';
                            this.oldPhoneCodeGet = false;
                        }
                        if (opt === 'new') {
                            this.newPhoneCodeText = '获取验证码';
                            this.newPhoneCodeGet = false;
                        }
                    }
                }, 1000);
            }
        }
    };
</script>
<style lang="stylus"  rel="stylesheet/stylus" scoped>
    @import '~assets/main.styl';

    .form-container {
        background: white;
        width: 100%;
        border-radius(8px);
        margin-top: 20px;
        padding: 30px;
        box-sizing: border-box;
        flex-y();
    }

    .el-form {
        width: 100%;
    }

    .phonecontent {
        flex-x(flex-start);

        .number {
            font-size: 14px;
            opacity: 0.65;
            margin-right: 20px;
        }

        .el-icon-success {
            width: 12px;
            height: 12px;
            color: green;
        }

        .success {
            font-size: 12px;
            opacity: 0.45;
            margin-left: 10px;
        }
    }

    .topmenu {
        height: 64px;
        border-radius: 8px;
    }

    .basecontent {
        background-color: white;
        border-radius: 8px;
        display: flex;
        flex-direction: column;
        margin-top: 20px;
        width: 880px;
        padding: 20px 0;
        box-sizing: border-box;

        .bottom-btn {
            flex-center();
            width: 100%;
        }

        button {
            width: 300px;
            margin-top: 20px;
        }

        .avatarcontent {
            display: flex;
            flex-direction: row;
            align-items: center;
            margin-top: 32px;
            margin-left: 24px;

            .avatar {
                margin-right: 32px;
                width: 100px;
                height: 100px;
                border-radius: 50px;
            }
        }

        .nicknamecontent {
            display: flex;
            flex-direction: row;
            align-items: center;
            margin-top: 47px;
            margin-left: 38px;

            .nickname {
                font-size: 14px;
                opacity: 0.65;
                margin-right: 90px;
            }

            .nicknameinput {
                width: 220px;
            }
        }

        .emailcontent {
            display: flex;
            flex-direction: row;
            align-items: center;
            margin-top: 24px;
            margin-left: 38px;

            .email {
                font-size: 14px;
                opacity: 0.65;
                margin-right: 62px;
            }

            .emailinput {
                width: 220px;
            }
        }

        .citycontent {
            display: flex;
            flex-direction: row;
            align-items: center;
            margin-top: 24px;

            .city {
                font-size: 14px;
                opacity: 0.65;
                margin-left: 38px;
                margin-right: 90px;
            }
        }

        .jobcontent {
            display: flex;
            flex-direction: row;
            align-items: center;
            margin-top: 24px;

            .job {
                font-size: 14px;
                opacity: 0.65;
                margin-left: 38px;
                margin-right: 90px;
            }
        }

        .describecontent {
            display: flex;
            flex-direction: row;
            align-items: center;
            margin-top: 24px;

            .describe {
                opacity: 0.65;
                font-display: 14px;
                margin-left: 38px;
                margin-right: 62px;
            }

            .describeinput {
                width: 400px;
            }
        }

        .labelcontent {
            display: flex;
            flex-direction: row;
            margin-top: 24px;
            align-items: center;

            .label {
                font-size: 14px;
                opacity: 0.65;
                margin-left: 38px;
                margin-right: 90px;
            }
        }

        .achievementcontent {
            display: flex;
            flex-direction: row;
            margin-top: 24px;

            .achievement {
                font-size: 14px;
                opacity: 0.65;
                margin-left: 38px;
                margin-right: 62px;
            }

            .achievementinput {
                width: 560px;
            }
        }
    }

    .pass {
        width: 100%;
        box-sizing: border-box;
        padding: 44px;
        border-bottom: 1px solid grayE8;

        >>>.el-input {
            width: 300px;
        }

        >>>.el-button {
            margin-left: 100px;
        }
    }

    .phone {
        box-sizing: border-box;
        // max-width: 983px;
        padding: 44px;

        >>>.el-input {
            width: 200px;
        }

        >>>.el-form-item {
            margin-bottom: 22px;
            width: 230px;
        }

        >>>.el-button {
            margin-left: 100px;
            margin-top: -20px;
        }

        .cell-phone {
            flex-x(flex-start);
        }
    }
</style>
